import React from 'react';

const NAV_ITEMS = [
  { i: "📰", l: "News",      p: "home" },
  { i: "📈", l: "Markets",   p: "markets" },
  { i: "💼", l: "Positions", p: "positions" },
  { i: "🏆", l: "Ranks",     p: "ranks" },
  { i: "👤", l: "Profile",   p: "profile" },
];

export default function BottomNav({ page, setPage, showToast, showAuth, user }) {
  function handleNav(p) {
    if (p === 'positions' && !user) {
      showAuth();
      return;
    }
    setPage(p);
  }

  return (
    <nav style={{ position: "fixed", bottom: 0, left: 0, right: 0, height: 64, background: "var(--bs-ink, #0a0a0a)", borderTop: "1px solid var(--bs-border, #1a1a1a)", display: "flex", justifyContent: "space-around", alignItems: "center", zIndex: 100 }}>
      {NAV_ITEMS.map(t => (
        <button key={t.p} onClick={() => handleNav(t.p)} style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 2, background: "none", border: "none", cursor: "pointer", padding: "8px 12px" }}>
          <span style={{ fontSize: 18 }}>{t.i}</span>
          <span style={{ fontSize: 10, fontWeight: page === t.p ? 700 : 400, color: page === t.p ? "var(--bs-green, #00e676)" : "#888" }}>{t.l}</span>
        </button>
      ))}
    </nav>
  );
}
